import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { RestApiProvider } from '../../providers/rest-api/rest-api';

/**
 * Generated class for the CommissionePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-commissione',
  templateUrl: 'commissione.html',
})
export class CommissionePage {
  dataInvio;
  nordini;
  errorMessage;
  constructor(public navCtrl: NavController, public navParams: NavParams,
    public rest: RestApiProvider,
  ) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad CommissionePage');
  }
  cerca() {
    this.rest.getOrdineMonthCount(this.dataInvio+"-01").subscribe(
      nordini => {
        this.nordini = nordini;

      //  alert(JSON.stringify(nordini));

      }
      ,
      error => this.errorMessage = <any>error);
  }

}
 



// WEBPACK FOOTER //
// ./src/pages/commissione/commissione.ts